
// 此文件由构建脚本自动生成，请勿手动修改
const gitInfo = {
  "branch": "RT_G800_Release_V0.4.3_20260915",
  "commitId": "c210f8810e2c6f6e9e76a6ad71f6e4e34f1fce7b",
  "commitTime": "2026-09-11 12:31:58",
  "buildTime": "2026-09-15 13:38:31"
};

// 在控制台美观地打印构建信息
function printBuildInfo() {
  const styles = {
    title: 'background: #606060; color: white; padding: 2px 6px; border-radius: 3px 3px 0 0;',
    content: 'background: #f8f8f8; color: #606060; padding: 2px 6px; border-radius: 0 0 3px 3px; font-weight: bold;',
    label: 'color: #606060; font-weight: bold;',
    value: 'color: #1890ff; font-weight: normal;'
  };

  console.log('%c System Info ', styles.title);
  console.log('%c Git Branch: %c' + gitInfo.branch, styles.label, styles.value);
  console.log('%c Git Commit ID: %c' + gitInfo.commitId, styles.label, styles.value);
  console.log('%c Git Commit Time: %c' + gitInfo.commitTime, styles.label, styles.value);
  console.log('%c Build Time: %c' + gitInfo.buildTime, styles.label, styles.value);
  
  // 创建不可枚举的属性，使得用户更难以通过普通方法删除这些信息
  Object.defineProperty(window, '__BUILD_INFO__', {
    value: gitInfo,
    writable: false,
    configurable: false,
    enumerable: false
  });
}

export { gitInfo, printBuildInfo };
export default gitInfo;
